import http from '../request';

// 获取医生详情
const getDoctorInfo = (params) => http.post('/doris/doctor/getDoctorInfo', params);

// 获取医生评价
const getComments = (params) => http.post('/doris/doctor/getComments', params);

export {
  getDoctorInfo,
  getComments
};
